<div class="modal-header"><h2 class="modal-title">Dealer Note</h2></div>
<div class="modal-body" (keyup.esc)="close()">
    <dx-form *ngIf="note" [formData]="note">
        <dxi-item dataField="primaryKey" [label]="{ text: 'Dealers' }" editorType="dxSelectBox" [editorOptions]="{ items: dealers, valueExpr: 'id', displayExpr: 'companyName', disabled: dealerFieldDisabled }">
        </dxi-item>
        <dxi-item
            dataField="notes"
            [editorType]="'dxTextArea'" [label]="{ text: 'Note' }"
            [editorOptions]="{
                height: 300,
                placeholder: 'Enter your note here...' }"
        ></dxi-item>
    </dx-form>
</div>

<div class="modal-footer">
    <button class="btn btn-success" (click)="save()" [disabled]="processing">Save</button>
    <button class="btn btn-default" (click)="close()">Cancel</button>
</div>